import { render, staticRenderFns } from "./ModalWaitLink.vue?vue&type=template&id=5af7cf64&"
import script from "./ModalWaitLink.vue?vue&type=script&lang=js&"
export * from "./ModalWaitLink.vue?vue&type=script&lang=js&"
import style0 from "./ModalWaitLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports